import { render, staticRenderFns } from "./SellerOfferBiddingDetails.vue?vue&type=template&id=8b83849c&scoped=true"
import script from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"
export * from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b83849c",
  null
  
)

export default component.exports